export default "__VITE_ASSET__CRkOVlR5__"